<template>
  <div class="main-wrapper-container row-list-container">
    <header-title :main-title="mainTitle" :btn-info="btnInfo"/>
    <template-pagination
        @changePage="changePage"
        @changeValue="changeValueSearch"
        :is-loading="isLoadingItems"
        :active-page="pagination.page"
        :page-total="pagination.total">
      <row-item v-for="item in itemsComputed" :key="item.id"
                :active-c-r-u-d="[
                    {
                      type: 'edit',
                      action: () => this.openModalTags(item)
                    },
                    {
                      type: 'remove',
                      action: () => this.openModalDeleteTags(item)
                    }
                ]"
                :id="item.id"
                :title="item.title"/>
    </template-pagination>
  </div>
</template>

<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import TemplatePagination from "@/components/entities/pagination/TemplatePagination.vue";
import paginationMixin from "@/mixins/pagination.mixin";
import RowItem from "@/components/entities/items/RowItem.vue";
import modalAgreement from "@/mixins/modals/modalAgreement";
import {mapActions, mapState} from "vuex";
import {api} from "@/middleware/api";

export default {
  name: "TagsPage",
  components: {RowItem, TemplatePagination, HeaderTitle},
  mixins: [paginationMixin, modalAgreement],
  data() {
    return {
      isLoadingItems: false,
      mainTitle: 'Библиотека тегов',
      btnInfo: {
        text: 'Создать тег',
        action: () => this.openModalTags()
      },
      items: [],
      timer: null
    }
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    ...mapActions('tags', ['ADD_TAG', 'REMOVE_TAG']),
    async fetchInfo(){
      this.IS_GLOBAL_LOADING(true);
      try {
        let { data } = await api.dashboard.adminTagsControllerFindMany({
          ...this.search !== ''
              ? { content: this.search }
              : {},
          limit: this.pagination.limit,
          offset: this.activeOffset
        })
        this.pagination.offset = data.offset;
        this.pagination.total = Math.ceil(data.total / this.pagination.limit)
        this.items = data.items
        this.items.forEach(item => {
          this.ADD_TAG(item)
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.IS_GLOBAL_LOADING(false);
      }
    },
    addTag(tag) {
      let itemIndex = this.items.findIndex(item => item.id === tag?.id);
      if(itemIndex !== -1) {
        this.items[itemIndex] = tag
      } else {
        this.items.push(tag)
      }
    },
    async removeTag(tag) {
      this.IS_GLOBAL_LOADING(true);
      try {
        await api.dashboard.adminTagsControllerRemove(tag.id)
        this.REMOVE_TAG(tag)
        let itemIndex = this.items.findIndex(item => item.id === tag?.id);
        if(itemIndex !== -1) {
          this.items.splice(itemIndex, 1)
        }
        this.alertSuccess('Тег успешно удален!')
      } catch (e) {
        this.alertError('Произошла ошибка удаления!')
      } finally {
        this.IS_GLOBAL_LOADING(false);
      }
    },
  },
  computed: {
    itemsComputed() {
      return this.items.map(item => {
        let valueRU = item.translations?.find(item => item.langCode === 'RU')?.content;
        let valueEN = item.translations?.find(item => item.langCode === 'EN')?.content;
        return {
          ...item,
          valueRU,
          valueEN,
          title: valueEN ? `${valueRU} | ${valueEN}` : valueRU
        }
      })
    }
  }
}
</script>

<style scoped>

</style>